import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfoBtnIcon = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "14px",
	height: "14px",
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-398.000000, -80.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				transform: "translate(383.000000, 69.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					transform: "translate(12.000000, 8.000000)",
					children: [
						/* @__PURE__ */ _jsx("mask", {
							id: "mask-dson24378dfohs",
							fill: "white",
							children: /* @__PURE__ */ _jsx("path", { d: "M10,4.91666667 C10.9666667,4.91666667 11.75,5.7 11.75,6.66666667 C11.75,7.63333333 10.9666667,8.41666667 10,8.41666667 C9.03333333,8.41666667 8.25,7.63333333 8.25,6.66666667 C8.25,5.7 9.03333333,4.91666667 10,4.91666667 L10,4.91666667 Z M10,12.4166667 C12.475,12.4166667 15.0833333,13.6333333 15.0833333,14.1666667 L15.0833333,15.0833333 L4.91666667,15.0833333 L4.91666667,14.1666667 C4.91666667,13.6333333 7.525,12.4166667 10,12.4166667 L10,12.4166667 Z M10,3.33333333 C8.15833333,3.33333333 6.66666667,4.825 6.66666667,6.66666667 C6.66666667,8.50833333 8.15833333,10 10,10 C11.8416667,10 13.3333333,8.50833333 13.3333333,6.66666667 C13.3333333,4.825 11.8416667,3.33333333 10,3.33333333 Z M10,10.8333333 C7.775,10.8333333 3.33333333,11.95 3.33333333,14.1666667 L3.33333333,16.6666667 L16.6666667,16.6666667 L16.6666667,14.1666667 C16.6666667,11.95 12.225,10.8333333 10,10.8333333 Z" })
						}),
						/* @__PURE__ */ _jsx("g", { fillRule: "nonzero" }),
						/* @__PURE__ */ _jsx("g", {
							mask: "url(#mask-dson24378dfohs)",
							fill: "#FFFFFF",
							children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 20,
								height: 20
							}) })
						})
					]
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgInfoBtnIcon);
export { ForwardRef as ReactComponent };
